import { Label } from '@fluentui/react-northstar';

const VersionNumber = (): React.ReactElement => {
  const VERSION_NUMBER = process.env.REACT_APP_VERSION_NUMBER;

  return <>{VERSION_NUMBER && <Label content={VERSION_NUMBER} />}</>;
};

export default VersionNumber;
